import React from 'react'

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button } from '@mui/material';
import styled from '@emotion/styled';

const PaymentStatusModal = ({ handleClose, isOpen, }) => {
    return (
        <React.Fragment>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
            >
                {/* <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className="editmodal-heading">
                    Payment Status
                </DialogTitle> */}
                <DialogContent className="edit-Modal-body" dividers>
                    <div className="card">
                        <div
                            style={{
                                borderRadius: 200,
                                height: 100,
                                width: 100,
                                background: "#F8FAF5",
                                margin: "0 auto",
                                display: "flex",
                            }}
                        >
                            <i className="checkmark">✓</i>
                        </div>
                        <h1>Success</h1>
                        <p>
                            Thank you. <br />You have done a successful payment <br /> for this Order.
                        </p>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button className="btn" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default PaymentStatusModal